(function () {
  class Ripple {
    constructor({ className = 'ripple', duration = 900, ensureOverflow = false } = {}) {
      this.className = className;
      this.duration = duration;
      this.ensureOverflow = ensureOverflow;
    }

    getTarget(event) {
      return null;
    }

    getContainer(target) {
      return target;
    }

    getGeometry(event, container) {
      var rect = container.getBoundingClientRect();
      var diameter = Math.max(rect.width, rect.height);
      var radius = diameter / 2;
      return {
        diameter,
        x: event.clientX - rect.left - radius,
        y: event.clientY - rect.top - radius,
      };
    }

    trigger(event) {
      var target = this.getTarget(event);
      if (!target) return false;

      var container = this.getContainer(target);
      if (!container) return false;

      if (this.ensureOverflow) {
        var style = getComputedStyle(container);
        if (style.overflow !== 'hidden') {
          container.style.overflow = 'hidden';
          container.style.position = 'relative';
        }
      }

      var existing = container.querySelector('.' + this.className.split(' ')[0]);
      if (existing) existing.remove();

      var { diameter, x, y } = this.getGeometry(event, container);
      var el = document.createElement('span');
      el.className = this.className;
      el.style.width = diameter + 'px';
      el.style.height = diameter + 'px';
      el.style.left = x + 'px';
      el.style.top = y + 'px';

      container.appendChild(el);
      setTimeout(function () { el.remove(); }, this.duration);
      return true;
    }
  }

  class ButtonRipple extends Ripple {
    constructor() {
      super({ className: 'ripple', duration: 900, ensureOverflow: true });
    }

    getTarget(event) {
      var el = event.target.closest('.accordion-group__item details > summary, .quantity__button, .login-gate .sign-in-cta--button, .most-popular-card .glymed-cta-button, .article-template__hubspot-button');
      if (!el || el.disabled) return null;
      if (el.closest('cart-drawer')) return null;
      return el;
    }
  }

  class FacetSummaryRipple extends Ripple {
    constructor() {
      super({ className: 'filter-ripple', duration: 900 });
    }

    getTarget(event) {
      return event.target.closest('.facets__summary');
    }
  }

  class ClearAllRipple extends Ripple {
    constructor() {
      super({ className: 'filter-ripple', duration: 900 });
    }

    getTarget(event) {
      return event.target.closest('.active-facets__button-remove');
    }
  }

  class CheckboxRipple extends Ripple {
    constructor() {
      super({ className: 'filter-ripple filter-ripple--checkbox', duration: 450 });
    }

    getTarget(event) {
      var label = event.target.closest('.facet-checkbox, .mobile-facets__label');
      if (!label) return null;

      var svg = label.querySelector(':scope > svg');
      if (!svg) return null;

      var rect = svg.getBoundingClientRect();
      if (
        event.clientX >= rect.left && event.clientX <= rect.right &&
        event.clientY >= rect.top && event.clientY <= rect.bottom
      ) {
        return svg;
      }
      return null;
    }

    getContainer(svg) {
      return svg.parentElement;
    }

    getGeometry(event, container) {
      var svg = container.querySelector(':scope > svg');
      var svgRect = svg.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var diameter = Math.max(svgRect.width, svgRect.height);
      var radius = diameter / 2;
      return {
        diameter,
        x: svgRect.left + svgRect.width / 2 - containerRect.left - radius,
        y: svgRect.top + svgRect.height / 2 - containerRect.top - radius,
      };
    }
  }

  var ripples = [
    new ButtonRipple(),
    new FacetSummaryRipple(),
    new CheckboxRipple(),
    new ClearAllRipple(),
  ];

  document.addEventListener('click', function (event) {
    for (var i = 0; i < ripples.length; i++) {
      if (ripples[i].trigger(event)) return;
    }
  });
})();
